import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import * as S from './FallbackMessage.styles';

export const FallbackMessage = ({ data }: { data: { answer: string } }) => {
  const { t } = useTranslation('intel');

  return (
    <div data-testid="fallback-assistant">
      <S.Content>{data.answer}</S.Content>
      <TooltipContainer label={t('intel:fallbackMessage.tooltip')}>
        <S.Badge>
          <span>
            <Icon iconName="GeneralKnowledge" size={20} />
          </span>
          <S.BadgeText> {t('intel:fallbackMessage.badgeTitle')}</S.BadgeText>
        </S.Badge>
      </TooltipContainer>
    </div>
  );
};
